var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.view == 'sinc-articulo-salientes')?_c('view-component',{attrs:{"change_from_dates_option":"","show_btn_delete":false,"show_btn_create":false,"model_name":"sync_to_meli_article"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }